import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"
import G from "../../utils/SvgGroup"

const NotionIconSvg = ({
  color = "primary",
  bg = "#f5f9f9",
  iconStyle,
  ...rest
}) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-5.8 0 27 14.8"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <Path d="m0 0h16v16h-16z" />
      </clipPath>
      <G clip-path="url(#a)">
        <Path
          fill={color}
          d="m5.83078.361481c-2.49733.184789-4.62034.354731-4.72016.374631-.27987.049909-.534468.239752-.654186.489608l-.104872.21985.010109 5.23979.014846 5.23974.159834.3248c.090025.1797.699359 1.019 1.363649 1.8829 1.31373 1.7032 1.4085 1.7983 1.9079 1.8482.14499.0149 1.23382-.035 2.41268-.1049 1.18391-.0748 3.0817-.1898 4.22072-.2545 4.8649-.2954 4.615-.2704 4.8946-.5102.3496-.2897.3247.1848.3395-6.18362.0101-5.39962.0051-5.75404-.0748-5.91892-.0948-.18479-.2647-.31462-2.4825-1.87316-1.4834-1.0389248-1.5882-1.0938876-2.2529-1.1039957-.2744-.0097922-2.54214.1399337-5.03442.3297767zm5.61412.684189c.2097.09477 1.7433 1.1637 1.9679 1.3687.06.06002.0799.10993.0499.13994-.0698.06001-9.56035.62449-9.83485.58437-.12477-.0199-.30956-.09476-.41443-.16489-.43465-.29471-1.51337-1.17885-1.51337-1.24361 0-.16994-.03507-.16994 4.1958-.47445.80928-.05496 2.13787-.15478 2.94715-.21985 1.7528-.139933 2.2775-.134879 2.6019.00979zm3.0169 2.73235c.0698.06981.1299.20469.1498.33451.0148.12004.0249 2.35772.0148 4.96498-.0148 4.47539-.0199 4.75519-.1049 4.88509-.0499.0799-.1497.1648-.2249.1898-.2094.085-10.15418.6494-10.35887.5894-.09477-.0249-.22491-.1048-.29472-.1746l-.12003-.1299-.01485-4.82501c-.01011-3.38653 0-4.88506.04012-5.01994.03001-.09982.10487-.21985.16994-.25965.09003-.06002.67945-.10993 2.70739-.22964 1.42367-.07992 3.62632-.2148 4.89012-.28966 3.0062-.18511 2.9964-.18511 3.1461-.03538z"
        />
        <Path
          fill={color}
          d="m11.789 5.43144c-.5396.03507-1.0191.08498-1.074.11498-.1649.08497-.2647.22491-.2846.38474-.0149.16489.035.18479.5742.24986l.2347.03001v2.13281c0 1.26857-.0199 2.10786-.0448 2.08286-.025-.03-.7341-1.10869-1.57847-2.39747-.84403-1.29353-1.54338-2.35772-1.55349-2.36751-.01011-.01011-.55942.0199-1.21866.06507-.80928.05496-1.25372.10487-1.34375.15478-.14498.07486-.30482.33957-.30482.51457 0 .10487.18984.15983.58943.15983h.20974v6.13373l-.33957.1049c-.2647.0799-.35473.1298-.39958.2296-.07992.1699-.07486.3247.00505.3247.03001 0 .59449-.035 1.24362-.0748 1.28372-.0749 1.4284-.11 1.56328-.3747.04011-.0799.07486-.1649.07486-.1898 0-.0199-.17468-.0799-.38474-.1298-.2148-.0499-.42959-.0999-.47445-.11-.08497-.0249-.09002-.1797-.09002-2.3277v-2.30272l1.51842 2.38272c1.59325 2.4973 1.79325 2.7822 2.03805 2.907.3048.1598 1.079.0499 1.4685-.2047l.12-.0749.0102-3.4064.0148-3.41149.2647-.04991c.3146-.06001.4596-.20469.4596-.45454 0-.15984-.0101-.16995-.1598-.16489-.0894.0041-.604.03411-1.1384.06917z"
        />
      </G>
    </Svg>
  )
}

export default NotionIconSvg
